// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kn1h","field":"styles_field__dUw6e","fieldCol":"styles_fieldCol__1K3MK","diffCol":"styles_diffCol__1P_cx","diff":"styles_diff__17daO"};